import { ErulRegistration } from './types';

export const getTooltipForErul = (reg?: ErulRegistration): string => {
  let statusInfo = '';
  if (reg?.status?.id) {
    const { requestDate, responseDate, status, user } = reg;
    const dateText =
      requestDate && responseDate
        ? `${requestDate} - ${responseDate}`
        : requestDate || responseDate || '';

    statusInfo = `. Запрос в ЕРУЛ: ${status.name}, ${dateText} (${user.fio})`;
  }
  return `Автоматическая перерегистрация в ЕРУЛ${statusInfo}`;
};
